import { get, isNil } from "lodash";
import { NODE_TYPES } from "utils/constants";
import { borrowsPublishedScreen, splitDelay } from "./next-steps";
import { CHECK_LEVELS, worstLevel } from "./step-checks";

export const SCREEN_STATES = {
  PUBLISHED: "PUBLISHED",
  SHARED: "SHARED",
  UNPUBLISHED: "UNPUBLISHED",
  NONE: "NONE",
};

export const screenState = (data = {}) => {
  if (data.screenPublished) return SCREEN_STATES.PUBLISHED;
  if (!isNil(data.screenFromName)) return SCREEN_STATES.SHARED;
  if (data.screenCount) return SCREEN_STATES.UNPUBLISHED;
  return SCREEN_STATES.NONE;
};

export const STEP_TONES = {
  OK: "ok",
  WARNING: "warning",
  ERROR: "error",
  MUTED: "muted",
};

const TONE_BY_LEVEL = {
  [CHECK_LEVELS.ERROR]: STEP_TONES.ERROR,
  [CHECK_LEVELS.WARNING]: STEP_TONES.WARNING,
};

export const stepTone = (node, nodes = [], checks = []) => {
  const level = worstLevel(checks);
  if (level) return TONE_BY_LEVEL[level];
  const data = get(node, "data") || {};
  const isScreen = (data.nodeType || NODE_TYPES.STATUS) === NODE_TYPES.STATUS;
  const shown = data.screenPublished || borrowsPublishedScreen(node, nodes);
  return isScreen && shown ? STEP_TONES.OK : STEP_TONES.MUTED;
};

export const describeStep = (node, t) => {
  const data = get(node, "data") || {};
  const nodeType = data.nodeType || NODE_TYPES.STATUS;
  const typeLabel =
    get(t("FORM.NODE_TYPES", { returnObjects: true }), nodeType) || nodeType;
  if (nodeType === NODE_TYPES.FORM_STEP)
    return `${typeLabel} · ${t("STATUS_NODE.FIELD_COUNT", {
      count: (get(data, "formDefinition.fields") || []).length,
    })}`;
  if (nodeType === NODE_TYPES.TIMER) {
    const seconds = Number(get(data, "config.delaySeconds")) || 0;
    if (!seconds) return typeLabel;
    const delay = splitDelay(seconds);
    return `${typeLabel} · ${delay.value} ${t(
      `CANVAS_EDITOR.STEPS.SHORT_UNITS.${delay.unit}`,
    )}`;
  }
  if (nodeType !== NODE_TYPES.STATUS) return typeLabel;
  const state = screenState(data);
  if (state === SCREEN_STATES.SHARED)
    return t("STATUS_NODE.SHARED_SCREEN", { name: data.screenFromName });
  return t(`CANVAS_EDITOR.STEPS.SCREEN.${state}`);
};
